import { render } from "./productCategory.vue?vue&type=template&id=ff824a92&scoped=true"
import script from "./productCategory.vue?vue&type=script&lang=js"
export * from "./productCategory.vue?vue&type=script&lang=js"

import "./productCategory.vue?vue&type=style&index=0&id=ff824a92&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff824a92"]])

export default __exports__